import styled from 'styled-components'

export const ListWrapper = styled.div`
  margin-top: 50px;
`
